import DatesService from '@linc-technologies/linced-common/services/dates';
import { isEmpty } from '@ember/utils';
import moment from 'moment';

export default class _DatesService extends DatesService {
  // periodsForDate resolves the timetable periods for the day covering `date`.
  async periodsForDate(date) {
    let day = this.dayForDate(date);
    if (isEmpty(day)) {
      return [];
    }
    let periods = await day.periods;
    return isEmpty(periods) ? [] : periods;
  }

  async periodForUnixTime(unixTime) {
    let time = moment.unix(unixTime);
    let date = time.format('YYYY-MM-DD');
    let periodForUnixTime = null;
    let periods = await this.periodsForDate(date);
    periods.forEach((period) => {
      let start = moment(`${date} ${period.startTime}`, 'YYYY-MM-DD HH:mm');
      let end = moment(`${date} ${period.endTime}`, 'YYYY-MM-DD HH:mm');
      if (time.isSameOrAfter(start) && time.isBefore(end)) {
        periodForUnixTime = period;
      }
    });
    return periodForUnixTime;
  }

  async periodAfterUnixTime(unixTime) {
    let time = moment.unix(unixTime);
    let date = time.format('YYYY-MM-DD');
    let periods = await this.periodsForDate(date);
    return periods.find((period) => {
      let start = moment(`${date} ${period.startTime}`, 'YYYY-MM-DD HH:mm');
      return time.isBefore(start);
    });
  }
}
